import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'News';

const NewsApi: any = baseApi(endpoint);

export default NewsApi;